import {
  IRegistration,
  ListRegistrationsExtensibleFields,
} from '@commenda/types/src/registration/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export function useRegistration(
  businessEntityId: number,
  registrationId: string,
  extend?: ListRegistrationsExtensibleFields[]
) {
  const queryString = new URLSearchParams();

  if (extend) queryString.append('extends', extend.join(','));

  const {
    data,
    error,
    mutate,
  }: {
    data?: { registration: IRegistration };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    // Don't fire until both ids are resolved (the add-registration modal
    // renders this hook with a null registrationId in create mode).
    businessEntityId && registrationId
      ? `business-entities/${businessEntityId}/registrations/${registrationId}?${queryString.toString()}`
      : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}
